import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const CheckboxUnselected = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <rect width="16" height="16" x="4" y="4" fill="none" stroke={color} strokeWidth="2" rx="2" />
    </StarryUIIcon>
);
